import classNames from 'classnames'
import { selectLanguageBasedOnBrowserLocale } from 'locale'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { countryIdToString, countryShortNameToString } from 'utils'

import RankingsBoxTableCell from './RankingsBoxTableCell'

function RankingsBoxTableIndicatorRow({ data, maxIndicator, indicator }) {
  const { t: translate } = useTranslation()
  const { countryId, rankCompared, rankCurrent } = data
  const isRankFirst = rankCurrent === 1
  const districtManager = !data.districtManagerName ? translate('rankings.emptyDistrictManager') : data.districtManagerName
  const storeName =
    data[`countryName${selectLanguageBasedOnBrowserLocale().toUpperCase()}`] ||
    data.storeName ||
    data.regionManagerName ||
    districtManager
  const percentOfMaxIndicator = Math.round((100 * data[indicator]) / maxIndicator)
  const countryShortName = (storeName || '').split(' ').pop()
  const fallbackCountryName = countryId && countryIdToString(countryId)

  return (
    <div className="rankings-box-table-row">
      <div className={classNames('row-wrapper flex-row', { 'rank-first': isRankFirst })}>
        <div
          className={classNames('cell cell-noLY', {
            negative: rankCurrent > rankCompared,
            positive: rankCurrent < rankCompared,
          })}
        >
          {rankCurrent}
        </div>

        <div className="cell cell-title flex-row">
          <div
            className={classNames('flag', `flag-${countryShortNameToString(countryShortName, fallbackCountryName)}`, {
              'hide-flag': !countryId,
            })}
          />

          {storeName}
        </div>

        <RankingsBoxTableCell
          cellName="indicator"
          column={indicator}
          percentOfMax={{
            [indicator]: percentOfMaxIndicator,
          }}
          {...data}
        />
      </div>
    </div>
  )
}

RankingsBoxTableIndicatorRow.propTypes = {
  data: PropTypes.object,
  indicator: PropTypes.string,
  maxIndicator: PropTypes.number,
}

export default RankingsBoxTableIndicatorRow
